import { PDFDocument } from "pdf-lib";

const A4 = [595.28, 841.89];
const MAX_DIM = 2200;

async function downscaleToJpeg(file) {
  const bmp = await createImageBitmap(file);
  const scale = Math.min(1, MAX_DIM / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
  bmp.close();
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.9));
  return new Uint8Array(await blob.arrayBuffer());
}

async function needsDownscale(file) {
  const bmp = await createImageBitmap(file);
  const big = Math.max(bmp.width, bmp.height) > MAX_DIM;
  bmp.close();
  return big;
}

export async function imagesToPdf(files, onProgress) {
  const doc = await PDFDocument.create();
  for (let fi = 0; fi < files.length; fi++) {
    const file = files[fi];
    let img;
    if (file.type === "image/png" && !(await needsDownscale(file))) {
      img = await doc.embedPng(new Uint8Array(await file.arrayBuffer()));
    } else if (file.type === "image/jpeg" && !(await needsDownscale(file))) {
      img = await doc.embedJpg(new Uint8Array(await file.arrayBuffer()));
    } else {
      img = await doc.embedJpg(await downscaleToJpeg(file));
    }
    const landscape = img.width > img.height;
    const [pw, ph] = landscape ? [A4[1], A4[0]] : A4;
    const margin = 24;
    const scale = Math.min((pw - margin * 2) / img.width, (ph - margin * 2) / img.height);
    const w = img.width * scale;
    const h = img.height * scale;
    const page = doc.addPage([pw, ph]);
    page.drawImage(img, { x: (pw - w) / 2, y: (ph - h) / 2, width: w, height: h });
    if (onProgress) onProgress(fi + 1, files.length);
  }
  return doc.save();
}
